export default "<p>\r\n  content-loader works!\r\n</p>\r\n"